import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import StageRepository from '@/shared/http/repositories/configuration/stage'
import ExpertRepository from '@/shared/http/repositories/configuration/expert'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'
import SchedulingTypeRepository from '@/shared/http/repositories/configuration/schedulingtype'
import ExpertMixin from '@/store/module/expert/mixin.js'
import AnalystMixin from '@/store/module/analyst/mixin.js'

import AccountMixin from '@/store/module/account/mixin'
import InsuranceMixin from '@/store/module/insurance/mixin.js'
import StageMixin from '@/store/module/stage/mixin.js'
import RegulationMixin from '@/store/module/regulation/mixin'
import RegulationTypeMixin from '@/store/module/regulationtype/mixin'
import SchedulingTypeMixin from '@/store/module/schedulingtype/mixin'
import BudgetSystemMixin from '@/store/module/budgetsystem/mixin.js'

import SinisterSearchData from '@/shared/models/regulation/auto/sinistersearchmodel.js'
import DistributionForms from './distribution-form'
import { isEmpty } from 'lodash'

export default {
  name: 'Distribution',
  mixins: [
    ActionsForm,
    InsuranceMixin,
    StageMixin,
    ExpertMixin,
    AnalystMixin,
    RegulationMixin,
    AccountMixin,
    RegulationTypeMixin,
    SchedulingTypeMixin,
    BudgetSystemMixin
  ],
  data () {
    return {
      data: SinisterSearchData,
      form: DistributionForms,
      en: en,
      es: es,
      ptBR: ptBR
    }
  },
  components: {
    Datepicker
  },
  mounted () {
    this.getAllSchedulingType()
    this.getAllExpertByArea(process.env.AreaAutos)
    this.getAllAnalysts()
  },
  computed: {
    getAllAnalyst: function () {
      var result = []
      if ((this.analysts) && (this.analysts.count) > 0) {
        var data = this.analysts.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.analyst.options = result
      }
      return result
    }
  },
  methods: {
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.$refs.tableGrid.Clear(null)
      this.objList = []
    },
    onLoad () {
      this.onLoadAllInsurer()
      this.onLoadAllStage()
      this.onLoadAllExpert()
    },
    onLoadAllInsurer () {
      loading.push()
      this.form.insurance.options = []
      InsuranceRepository.GetAllByAreaMnemonic(process.env.AreaAutos)
        .then((response) => {
          this.form.insurance.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllStage () {
      loading.push()
      this.form.stage.options = []
      StageRepository.GetAllByAreaMnemonic(process.env.AreaAutos)
        .then((response) => {
          this.form.stage.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllExpert () {
      loading.push()
      this.form.expert.options = []
      this.form.expertID.options = []
      ExpertRepository.GetAllByAreaMnemonic(process.env.AreaAutos)
        .then((response) => {
          this.form.expert.options = this.onResultSelect2(response)
          this.form.expertID.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSearch () {
      const isFormValid = Tools.ValidateForms(this.form, this.data, this)

      if (!isFormValid) {
        return
      }

      loading.push()

      RegulationAutoRepository.Search(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.data)
        .then((response) => {
          console.log(response)
          const hasRegulation = response && response.data.count > 0

          if (!hasRegulation) {
            this.onResultGrid(response)
            return
          }

          let regulations = response.data.data

          regulations.forEach(regulation => {
            const hasSchedulingType = !isEmpty(regulation.schedulingTypeID)

            regulation.experts = []
            regulation.analysts = []

            regulation.experts = hasSchedulingType
              ? this.getExpertBySchedulingType(regulation.schedulingTypeID)
              : this.experts.data.map(x => ({ 'label': x.name, 'value': x.id }))

            regulation.analysts = this.analysts.data.map(x => ({ 'label': x.name, 'value': x.id }))
          })

          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    getExpertBySchedulingType (schedulingTypeID) {
      const hasExperts = this.experts && this.experts.count > 0

      if (!hasExperts) {
        return []
      }

      const statusIsTrue = x => x.status
      const regulatorHasSchedulingType = x => x.schedulingType.includes(schedulingTypeID)
      const filter = x => statusIsTrue(x) && regulatorHasSchedulingType(x)

      let expertsBySchedulingType = this.experts.data
        .filter(filter)
        .map(x => ({ 'label': x.name, 'value': x.id }))

      if (!expertsBySchedulingType) {
        return this.experts
      }

      return expertsBySchedulingType
    },
    distribute () {
      var selecteds = this.objList.filter(x => x.isChecked).map(e => {
        return { id: e.id, expertID: e.expertID, analystID: e.analystID }
      })
      if (Array.isArray(selecteds) && selecteds.length) {
        loading.push()
        RegulationAutoRepository.Distribute(selecteds)
          .then((response) => {
            this.$refs.alert.ShowSuccess(response.data.data.filter(x => x.isDistributed).length + ' processos foram distribuídos com sucesso!')

            response.data.data.filter(x => x.isDistributed).forEach(e => {
              var index = this.objList.findIndex(item => item.id === e.id)
              this.objList.splice(index, 1)
            })
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (obj) {
      // console.log(obj)
    },
    onSelectExpert (obj) {
      this.objList.some(x => {
        if (x.id === obj.id) {
          x.isChecked = true
          return true
        }
        return false
      })
    },
    onSelectAnalyst (obj) {
      this.objList.some(x => {
        if (x.id === obj.id) {
          x.isChecked = true
          return true
        }
        return false
      })
    },
    onFullscreen () {
      if (this.$refs.frmSinister.showForm) {
        this.$refs.frmSinister.showForm = false
      } else {
        this.$refs.frmSinister.showForm = true
      }
    },
    getAllExpert () {
      var result = []
      if (Array.isArray(this.form.expert)) {
        result = this.form.expert.filter(x => x.status).map(e => {
          return { 'label': e.name, 'value': e.id }
        })
        this.form.expertID.options = result
      }
      return result
    },
    getAllSchedulingType () {
      SchedulingTypeRepository.GetAll()
        .then((response) => {
          var result = []
          var type = response.data
          if (type && type.data && type.count > 0) {
            var data = type.data
            for (var i in data) {
              if (data[i].status) {
                result.push({ 'text': data[i].name, 'value': data[i].id })
              } else {
                result.push({ 'text': data[i].name, 'value': data[i].id, disabled: true })
              }
            }
            this.form.schedulingTypeID.options = result
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/distribution/distribution.js